<template>
  <div>
    <pre></pre>
    <div class="pc-block__title">
      {{ $t('pc.verification.title') }}
    </div>
    <p>{{ $t('pc.verification.text') }}:</p>
    <pc-checkbox-input
      :disabled="!userInfo.sms_otp_is_available"
      class="pc-verification-checkbox"
      :value="value"
      @click.native="setValue(true)"
    >
      SMS
    </pc-checkbox-input>
    <pc-checkbox-input
      class="pc-verification-checkbox"
      :value="!value"
      @click.native="setValue(false)"
    >
      Email
    </pc-checkbox-input>

  </div>
</template>

<script>
import PcCheckboxInput from '@/components/inputs/PcCheckboxInput'
import {api} from '@/api/api'
import {mapGetters} from 'vuex'
export default {
  name: 'PcVerificationWay',
  components: {PcCheckboxInput},
  data(){
    return {
      value: true
    }
  },
  computed:{
    ...mapGetters(['userInfo'])
  },
  mounted() {
    if(!this.userInfo.sms_otp_is_available || this.userInfo.confirmation_type === 'email') {
      this.value=false
    }
  },
  methods: {
    async setValue(val) {

      if (this.userInfo.sms_otp_is_available) {
        this.value = val
        const confirmation_type = val ? 'sms' : 'email'
        const formData = new FormData()
        formData.append('confirmation_type', confirmation_type)
        try {
         const {data} = await api.auth.updateUserInfo(formData)
          await this.$store.dispatch('setUserInfo', data)
        }catch(err) {
          console.log(err)
        }
      }
    }
  }


}
</script>

<style scoped lang="scss">
.pc-verification-checkbox {
  margin-top: 30px;
}
</style>
